import { apiUrl } from '@/constants';
import axios from 'axios';

const state = {
  items: [],
  categories : [],
};
const mutations = {
  SET_CATEGORIES(state, categories){
    state.categories = categories;
  },
  SET_ITEMS(state, items) {
    state.items = items;
  },
  ADD_ITEM(state, item) {
    state.items.push(item);
  },
  UPDATE_ITEM(state, updatedItem) {
    const index = state.items.findIndex(item => item.id === updatedItem.id);
    if (index !== -1) {
      state.items.splice(index, 1, updatedItem);
    }
  },
  DELETE_ITEM(state, itemId) {
    state.items = state.items.filter(item => item.id !== itemId);
  }
};

const actions = {
  async fetchCategories({commit}){
    try {
      const response = await axios.get(`${apiUrl}/categories`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      commit('SET_CATEGORIES', response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }

  },
  async fetchItems({ commit }) {
    try {
      const response = await axios.get(`${apiUrl}/items`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      commit('SET_ITEMS', response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  },
  async addItem({ commit }, newItem) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${apiUrl}/items`, newItem, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      commit('ADD_ITEM', response.data);
    } catch (error) {
      console.error('Error creating item:', error);
    }
  },
  async updateItem({ commit }, updatedItem) {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${apiUrl}/items/${updatedItem.id}`, updatedItem, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      commit('UPDATE_ITEM', updatedItem);
    } catch (error) {
      console.error('Error updating item:', error);
    }
  },
  async deleteItem({ commit }, itemId) {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${apiUrl}/items/${itemId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      commit('DELETE_ITEM', itemId);
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  },
};

const getters = {
  getItems: (state) => state.items,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
